import {
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableHeader,
	TableRow,
} from "@lawline/ui/components/table";
import { useTranslations } from "use-intl";

import { compactNumberFmt } from "@platform/fmt";
import type { BillingOverview } from "../billing.types";

// Shown when billing is active: this period's cost, usage chart, billing
// information (left) + connected payment card (right), then the plan table.
export function BillingPlan({ overview }: { overview: BillingOverview }) {
	const t = useTranslations("billing.plan");
	return (
		<div className="overflow-hidden rounded-md border">
			<Table>
				<TableHeader>
					<TableRow>
						<TableHead>{t("heading")}</TableHead>
						<TableHead className="text-right">{t("requestsPerMinute")}</TableHead>
						<TableHead className="text-right">{t("lawlineTokensPerMonth")}</TableHead>
					</TableRow>
				</TableHeader>
				<TableBody>
					<TableRow>
						<TableCell className="font-medium capitalize">{overview.rateTier}</TableCell>
						<TableCell className="text-right font-mono">{overview.requestsPerMinute}</TableCell>
						<TableCell className="text-right font-mono">
							{compactNumberFmt.format(overview.monthlyLawlineQuota)}
						</TableCell>
					</TableRow>
				</TableBody>
			</Table>
		</div>
	);
}
